import {Box, Heading, Hide, HStack, Show, Text, VStack} from 'platform/foundation';

import {isNotNil} from 'ramda-adjunct';

import {EMPTY_PLACEHOLDER, TestIdProps} from 'shared/web';

import i18n from '../../../i18n/i18n';
import {AvailableCar} from '../../../types/AvailableCar';
import {PriceReportType} from '../../../types/PriceReportType';
import {DEFAULT_VALUE} from '../consts/defaultValue';

interface VehicleCardContentAdvertisementStatusProps extends TestIdProps {
  vehicle: AvailableCar;
  priceReport: PriceReportType;
  isMyVehicle: boolean;
}

export function VehicleCardContentAdvertisementStatus(
  props: VehicleCardContentAdvertisementStatusProps
) {
  const nDaysText = isNotNil(props.vehicle.days_on_stock)
    ? i18n.t('general.labels.nDays', {
        count: props.vehicle.days_on_stock,
      })
    : DEFAULT_VALUE;

  return (
    <>
      <Hide onMobile>
        <Box flex={1}>
          <VStack spacing={1}>
            <Hide when={props.isMyVehicle}>
              <Heading size={5} alternative>
                {nDaysText}
              </Heading>
              <Text size="xSmall" color="secondary">
                {i18n.t('general.labels.inAdvertisement')}
              </Text>
            </Hide>
            <Show when={props.isMyVehicle}>
              <Heading size={5} alternative>
                {EMPTY_PLACEHOLDER}
              </Heading>
            </Show>
          </VStack>
        </Box>
      </Hide>

      <Show onMobile>
        <HStack justify="space-between" align="center">
          <Text size="xSmall" color="secondary">
            {i18n.t('page.overview.inAdvertising')}
          </Text>
          <Hide when={props.isMyVehicle}>
            <Heading size={5} alternative>
              {nDaysText}
            </Heading>
          </Hide>
          <Show when={props.isMyVehicle}>
            <Heading size={5} alternative>
              {EMPTY_PLACEHOLDER}
            </Heading>
          </Show>
        </HStack>
      </Show>
    </>
  );
}
